import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Switch } from 'react-router';

import { routerLocationShape } from 'lib/common/prop-types';

import BusinessPageComponent from 'components/business';
import BusinessFAQ from 'components/business/faq';
import EmployeeParking from 'components/business/employee-parking';
import VisitorParking from 'components/business/visitor-parking';

import cleanupBusinessPageState from 'action-creators/brand/cleanup-business-page-state'

const propTypes = {
  routerLocation: routerLocationShape.isRequired,
  cleanupBusinessPageState: PropTypes.func.isRequired,
};

class BusinessPage extends Component {
  componentWillUnmount() {
    this.props.cleanupBusinessPageState();
  }

  render() {
    return (
      <div className="business-page">
        <Switch location={this.props.routerLocation}>
          <Route path="/business/faq" component={BusinessFAQ} />
          <Route path="/business/clients-visit-you" component={VisitorParking} />
          <Route path="/business/visit-your-clients" component={EmployeeParking} />
          <Route path="/business" exact component={BusinessPageComponent} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { location: routerLocation } = state.router;
  if (!routerLocation) {
    ({ routerLocation } = ownProps);
  }

  return { routerLocation };
};
const mapDispatchToProps = dispatch => (
  bindActionCreators({ cleanupBusinessPageState }, dispatch)
);

BusinessPage.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(BusinessPage);
